import { UseFormReturn } from 'react-hook-form';

import { BaseDataLanguage } from '@work4all/models/lib/Classes/BaseDataLanguage.entity';
import { Contact } from '@work4all/models/lib/Classes/Contact.entity';
import { Contract } from '@work4all/models/lib/Classes/Contract.entity';
import { ContractGroup } from '@work4all/models/lib/Classes/ContractGroup.entity';
import { CostCenter } from '@work4all/models/lib/Classes/CostCenter.entity';
import { Customer } from '@work4all/models/lib/Classes/Customer.entity';
import { LookUp } from '@work4all/models/lib/Classes/LookUp.entity';
import { PaymentKind } from '@work4all/models/lib/Classes/PaymentKind.entity';
import { PriceGroup } from '@work4all/models/lib/Classes/PriceGroup.entity';
import { Project } from '@work4all/models/lib/Classes/Project.entity';
import { TaxGroup } from '@work4all/models/lib/Classes/TaxGroup.entity';

import { useFormUpdate } from '../../../utils/use-form-update';
import { ServiceContractsFormValue } from '../types';

export const useServiceContractFormUpdate = (
  form: UseFormReturn<ServiceContractsFormValue>
) => {
  const { getValues } = form;

  useFormUpdate(
    {
      'mainAddress.businessPartner': (businessPartner: Customer) => {
        const mainAddressSdObjMemberId = businessPartner?.id ?? 0;
        const mainContactId = businessPartner?.mainContactId;
        const mainAddressContactId = businessPartner?.isPrivateCustomer
          ? 0
          : mainContactId || 0;

        return { mainAddressSdObjMemberId, mainAddressContactId };
      },
      'mainAddress.contact': (contact: Contact) => {
        const mainAddressContactId = contact?.id ?? 0;
        return { mainAddressContactId };
      },
      'deliveryAddress.businessPartner': (businessPartner: Customer) => {
        const deliveryAddressSdObjMemberId = businessPartner?.id ?? 0;
        const mainContactId = businessPartner?.mainContactId;
        const deliveryAddressContactId = businessPartner?.isPrivateCustomer
          ? 0
          : mainContactId || 0;

        return { deliveryAddressSdObjMemberId, deliveryAddressContactId };
      },
      'deliveryAddress.contact': (contact: Contact) => {
        const deliveryAddressContactId = contact?.id ?? 0;
        return { deliveryAddressContactId };
      },
      'endCustomer.businessPartner': (businessPartner: Customer) => {
        const endCustomerSdObjMemberId = businessPartner?.id ?? 0;
        const mainContactId = businessPartner?.mainContactId;
        const endCustomerContactId = businessPartner?.isPrivateCustomer
          ? 0
          : mainContactId || 0;

        return { endCustomerSdObjMemberId, endCustomerContactId };
      },
      'endCustomer.contact': (contact: Contact) => {
        const endCustomerContactId = contact?.id ?? 0;
        return { endCustomerContactId };
      },
      language: (language: BaseDataLanguage) => {
        const languageId = language?.id ?? null;
        return { languageId };
      },
      project: (project: Project) => {
        const projectId = project?.id ?? 0;
        const businessPartnerField = getValues('mainAddress.businessPartner');
        if (businessPartnerField !== null) {
          return { projectId };
        } else {
          const businessPartner = project?.customer ?? null;
          return {
            projectId,
            'mainAddress.businessPartner': businessPartner,
          };
        }
      },
      contract: (contract: Contract) => {
        const contractId = contract?.id ?? 0;
        return { contractId };
      },
      group: (group: ContractGroup) => {
        const groupId = group?.id ?? 0;
        return { groupId };
      },
      typeOfContract: (typeOfContract: LookUp) => {
        const kindLookupId = typeOfContract?.id ?? 0;
        return { kindLookupId };
      },
      paymentKind: (paymentKind: PaymentKind) => {
        const paymentId = paymentKind?.id ?? 0;
        return { paymentId };
      },
      priceGroup: (priceGroup: PriceGroup) => {
        const priceGroupId = priceGroup?.id ?? 0;
        return { priceGroupId };
      },
      costCenter: (costCenter: CostCenter) => {
        const costCenterId = costCenter?.id ?? 0;
        return { costCenterId };
      },
      taxGroup: (taxGroup: TaxGroup) => {
        const taxGroupId = taxGroup?.id ?? 0;
        return { taxGroupId };
      },
      name: () => {
        const addition = getValues('addition') ?? '';
        return { addition };
      },
    },
    form
  );
};
